export default {
    "MENUS": {
        "NAME": "Név",
        "COLOR": "Szín",
        "LINK": "Link",
        "BACKGROUND": "Háttér kép",
        "ICON": "Ikon",
        "ACTIVE": "Aktív",
        "TILE": "Csempe",
        "ORDER": "Sorrend",
        "IS_EXTERNAL": "Külső link",
        "IS_NEW_TAB": "Új fülön",
        "TYPE": "Típus",
        "PARAMS": "Paraméterek",
        "BLOCK": "Blokk",
        "BUTTON": "Gomb",
    }
}



// WEBPACK FOOTER //
// ./src/i18n/messages/hu/menus.js